<template>
  <section class="app-mobile">
    <div class="app-mobile__glow app-mobile__glow--orange"></div>
    <div class="app-mobile__glow app-mobile__glow--blue"></div>
    <div class="app-mobile__dots"></div>

    <div class="app-mobile__grid">
      <div class="app-mobile__content">
        <p class="app-mobile__tag">{{ $t('home_page.assurapp_title') }}</p>
        <h2 class="app-mobile__title">
          {{ $t('home_page.download_app_title[0]') }}
          <span class="app-mobile__title--accent">{{ $t('home_page.download_app_title[1]') }}</span
          >,
          {{ $t('home_page.download_app_title[2]') }}
          <span class="app-mobile__title--accent">{{ $t('home_page.download_app_title[3]') }}</span>
        </h2>
        <p class="app-mobile__subtitle">
          {{ $t('home_page.assurapp_intro') }}
        </p>

        <ul class="app-mobile__features">
          <li v-for="(item, index) in features" :key="index">
            <span class="app-mobile__check">
              <i class="material-icons">check</i>
            </span>
            {{ item }}
          </li>
        </ul>

        <div class="app-mobile__badges">
          <a
            class="app-mobile__badge app-mobile__badge--shadow"
            href="https://play.google.com/store/apps/details?id=com.afdecoding.assurafmobile"
            target="_blank"
            rel="nofollow noopener noreferrer"
            aria-label="Télécharger sur Google Play"
          >
            <img
              :src="require('../../../assets/img/logo_playStore.png')"
              class="app-mobile__badge-img"
              alt="Google Play"
            />
          </a>
          <a
            class="app-mobile__badge app-mobile__badge--shadow"
            href="https://apps.apple.com/sn/app/assuraf/id1641569465?l=fr"
            target="_blank"
            rel="nofollow noopener noreferrer"
            aria-label="Télécharger sur l'App Store"
          >
            <img
              :src="require('../../../assets/img/logo-appStore.png')"
              class="app-mobile__badge-img"
              alt="App Store"
            />
          </a>
        </div>

        <div class="app-mobile__qr">
          <div class="app-mobile__qr-code">
            <a target="_blank" href="https://qr1.be/2L6E" rel="nofollow noopener noreferrer">
              <img
                :src="require('../../../assets/img/qr_code/qr_code assuraf.jpg')"
                alt="QR code Assur'App"
              />
            </a>
          </div>
          <div class="app-mobile__qr-text">
            <strong>{{ $t('home_page.scan_qr_code_app_text') }}</strong>
            <span> {{ $t('home_page.assurapp_feature') }}</span>
          </div>
        </div>
      </div>

      <div class="app-mobile__phone">
        <div class="app-mobile__phone-ring app-mobile__phone-ring--one"></div>
        <div class="app-mobile__phone-ring app-mobile__phone-ring--two"></div>
        <img
          :src="require('../../../assets/img/download_page/new_assur_app.png')"
          class="app-mobile__phone-img"
          alt="Aperçu de l'application Assur'App"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'app_mobile_section',
  data() {
    return {
      title: 'Assuraf',
      description:
        "Le meilleur de l'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale."
    };
  },

  computed: {
    features() {
      return [
        this.$t('home_page.download_app_description_desktop[1]'),
        this.$t('home_page.download_app_description_desktop[2]'),
        this.$t('home_page.download_app_description_desktop[3]'),
        this.$t('home_page.download_app_description_desktop[4]')
      ];
    }
  },

  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          charset: 'utf-8'
        },
        {
          name: 'description',
          content: this.description
        }
      ]
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style lang="less" scoped>
.app-mobile {
  position: relative;
  overflow: hidden;
  padding: 90px 32px;
  background: linear-gradient(160deg, #fffdf9 0%, #fff6e8 55%, #fff 100%);

  &__glow {
    position: absolute;
    border-radius: 50%;
    filter: blur(90px);
    opacity: 0.45;
    pointer-events: none;

    &--orange {
      width: 480px;
      height: 480px;
      background: rgba(255, 164, 9, 0.35);
      top: -160px;
      right: -120px;
    }

    &--blue {
      width: 420px;
      height: 420px;
      background: rgba(87, 149, 184, 0.3);
      bottom: -160px;
      left: -140px;
    }
  }

  &__dots {
    position: absolute;
    top: 14%;
    left: 6%;
    width: 120px;
    height: 120px;
    background-image: radial-gradient(rgba(255, 164, 9, 0.4) 2px, transparent 2px);
    background-size: 22px 22px;
    opacity: 0.5;
    pointer-events: none;
  }

  &__grid {
    position: relative;
    z-index: 2;
    display: grid;
    grid-template-columns: 1.15fr 0.85fr;
    gap: 48px;
    align-items: center;
    max-width: 1120px;
    width: 100%;
    margin: 0 auto;
  }

  &__tag {
    display: inline-block;
    background: rgba(255, 164, 9, 0.14);
    color: #b06d00;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    padding: 7px 16px;
    border-radius: 999px;
    margin-bottom: 20px;
  }

  &__title {
    font-size: 46px;
    line-height: 1.15;
    font-weight: 800;
    color: #2b2b2b;
    margin: 0 0 16px;

    &--accent {
      color: #ffa409;
    }
  }

  &__subtitle {
    font-size: 17px;
    line-height: 1.6;
    color: #59595b;
    font-weight: 400;
    max-width: 480px;
    margin: 0 0 24px;
  }

  &__features {
    list-style: none;
    margin: 0 0 32px;
    padding: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px 20px;

    li {
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: 600;
      color: #2b2b2b;
    }
  }

  &__check {
    flex-shrink: 0;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: #ffa409;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;

    i {
      font-size: 16px;
      line-height: 1;
    }
  }

  &__badges {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 28px;
  }

  &__badge {
    display: block;
    border-radius: 14px;
    overflow: hidden;
    transition:
      transform 0.25s ease,
      box-shadow 0.25s ease;

    &--shadow {
      box-shadow: 0 10px 26px rgba(43, 43, 43, 0.18);
    }

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 16px 34px rgba(255, 164, 9, 0.35);
    }
  }

  &__badge-img {
    display: block;
    width: 168px;
    height: auto;
  }

  &__qr {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  &__qr-code {
    width: 74px;
    height: 74px;
    flex-shrink: 0;
    background: #fff;
    border: 1px solid #f0e3cf;
    border-radius: 12px;
    padding: 6px;
    box-shadow: 0 6px 16px rgba(43, 43, 43, 0.08);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 6px;
    }
  }

  &__qr-text {
    display: flex;
    flex-direction: column;
    gap: 2px;

    strong {
      color: #2b2b2b;
      font-size: 15px;
    }

    span {
      color: #898d8f;
      font-size: 13px;
      font-weight: 400;
    }
  }

  &__phone {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__phone-ring {
    position: absolute;
    border-radius: 50%;
    border: 2px dashed rgba(255, 164, 9, 0.45);

    &--one {
      width: 420px;
      height: 420px;
    }

    &--two {
      width: 520px;
      height: 520px;
      border-color: rgba(87, 149, 184, 0.35);
    }
  }

  &__phone-img {
    position: relative;
    z-index: 2;
    width: 300px;
    max-width: 100%;
    height: auto;
    filter: drop-shadow(0 30px 40px rgba(43, 43, 43, 0.25));
  }
}

@media (max-width: 991px) {
  .app-mobile {
    padding: 70px 24px;

    &__grid {
      grid-template-columns: 1fr;
      gap: 32px;
      text-align: center;
    }

    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &__title {
      font-size: 36px;
    }

    &__subtitle {
      max-width: 520px;
    }

    &__features {
      text-align: left;
      width: 100%;
      max-width: 520px;
    }

    &__badges {
      justify-content: center;
    }

    &__phone-ring {
      &--one {
        width: 340px;
        height: 340px;
      }

      &--two {
        width: 430px;
        height: 430px;
      }
    }

    &__phone-img {
      width: 240px;
    }
  }
}

@media (max-width: 600px) {
  .app-mobile {
    padding: 56px 20px;

    &__title {
      font-size: 29px;
    }

    &__tag {
      font-size: 12px;
    }

    &__subtitle {
      font-size: 15px;
    }

    &__features {
      grid-template-columns: 1fr;
      gap: 8px;
      margin-bottom: 26px;
    }

    &__badges {
      flex-direction: column;
      align-items: center;
      gap: 14px;
    }

    &__badge-img {
      width: 196px;
    }

    &__qr {
      flex-direction: column;
      text-align: center;
    }

    &__phone-img {
      width: 210px;
    }
  }
}
</style>
